import React from 'react';

import { Tournament } from '@/nikeone/components/TournamentList';
import withSportHeader from '@/common/components/sportWrapper';
import i18n from '@i18n';
import { SEARCH_RESULT_TOURNAMENTS_BOXSTORE } from '../services/results';

function Tournaments({ items }) {
    if (!items || items.length === 0) {
        return null;
    }

    const sportsTournamentsMap = items
        .sort((o1, o2) => o1.sportId > o2.sportId)
        .reduce((ret, item) => {
            const tournaments = ret[item.sportId] || [];
            tournaments.push(item);
            ret[item.sportId] = tournaments;
            return ret;
        }, {});
    return (
        <>
            <div className="header-section">{i18n('search.result.type.t')}</div>
            {Object.values(sportsTournamentsMap).map(tournaments => (
                <Sport
                    key={tournaments[0].sportId}
                    sportId={tournaments[0].sportId}
                    sportDisplayName={tournaments[0].sportName}
                    tournaments={tournaments}
                />
            ))}
        </>
    );
}

function Sport({ sportId, sportDisplayName, tournaments }) {
    return withSportHeader(
        sportId,
        sportDisplayName,
        tournaments.map(({ boxId, tournamentName, tournamentNote, sportId }) => (
            <Tournament
                key={boxId}
                sportId={sportId}
                tour={{ label: tournamentName, boxId, tournamentNote }}
                boxStore={SEARCH_RESULT_TOURNAMENTS_BOXSTORE}
            />
        ))
    );
}

export default Tournaments;
